import { useCallback, useEffect, useState } from 'react';
import savedFiltersService from '../services/savedFiltersService';

export default function useSavedFilters(pageKey) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!pageKey) return;
    setLoading(true);
    setError(null);
    try {
      const res = await savedFiltersService.list(pageKey);
      setItems(Array.isArray(res?.data) ? res.data : []);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [pageKey]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const save = useCallback(async (name, currentFilters, visibility = 'private') => {
    const res = await savedFiltersService.create({
      page_key: pageKey,
      name,
      filters: currentFilters || {},
      visibility,
    });
    await refresh();
    return res?.data;
  }, [pageKey, refresh]);

  const update = useCallback(async (id, patch) => {
    const res = await savedFiltersService.update(id, patch);
    await refresh();
    return res?.data;
  }, [refresh]);

  const remove = useCallback(async (id) => {
    await savedFiltersService.remove(id);
    await refresh();
  }, [refresh]);

  return { items, loading, error, refresh, save, update, remove };
}
